// Route-level code-splitting boundaries (perf sweep — router `lazy:`).
//
// The router defers heavy / infrequently-visited route Components to their
// own chunks (see router.tsx lazyRoute). Two shared pieces make that safe:
//
//   * RouteHydrateFallback — rendered in the shell's <Outlet/> slot while a
//     lazy chunk downloads on the INITIAL page load (client-side navigations
//     keep the previous screen until the chunk lands, so no flash there).
//     Skeleton rows per spec 43 loading_state AC ("skeletons first").
//
//   * RouteErrorBoundary — the per-route error element. A failed chunk fetch
//     (stale deploy, offline) or a render crash inside the route shows a
//     bounded, retryable error INSIDE the shell — LeftRail/TopBar navigation
//     stays interactive; reload re-fetches the chunk.

import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router";

import { Button, ErrorState, Loading } from "@novemai/components";

export function RouteHydrateFallback(): React.ReactElement {
  const { t } = useTranslation();
  return <Loading label={t("app.loading")} rows={4} className="p-6" />;
}

export function RouteErrorBoundary(): React.ReactElement {
  const { t } = useTranslation();
  const error = useRouteError();
  // Keep the trace visible locally; the error object is structural, not PII.
  console.error("customer-web route boundary caught:", error);
  return (
    <ErrorState
      className="p-6"
      title={t("errors.boundary_title")}
      description={t("errors.fallback")}
      action={
        <Button
          variant="secondary"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("errors.boundary_retry")}
        </Button>
      }
    />
  );
}
